import { supabase } from "@/integrations/supabase/client";

export function useTrackExternalClick() {
  const trackClick = async (linkId: string, url: string) => {
    try {
      // Obter usuário atual (pode ser null se não logado)
      const { data: { user } } = await supabase.auth.getUser();
      
      // Registrar clique
      await supabase
        .from('external_link_clicks')
        .insert({
          link_id: linkId,
          user_id: user?.id || null,
          clicked_at: new Date().toISOString()
        });

      // Abrir link em nova aba
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (error) {
      console.error('Error tracking external click:', error);
      // Mesmo com erro, abre o link
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return { trackClick };
}
